import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const TEMPLATE_API_URL = "dialer/message-templates/";

export const fetchTemplates = createAsyncThunk("templates/fetchTemplates", async (params, thunkAPI) => {
    try {
        const state = thunkAPI.getState();
        const token = state.auth.token;
        if (!token) return;

        const response = await axios.get(TEMPLATE_API_URL, {
            params: params,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(
            error.response?.data?.message ||
            error.message ||
            "Failed to fetch templates list"
        );
    }
});

const templateSlice = createSlice({
    name: "template",
    initialState: {
        templates_list: [],
        templates_list_loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchTemplates.pending, (state) => {
            state.templates_list_loading = true;
            state.error = null;
        })
        .addCase(fetchTemplates.fulfilled, (state, action) => {
            state.templates_list_loading = false;
            state.templates_list = action.payload;
        })
        .addCase(fetchTemplates.rejected, (state, action) => {
            state.templates_list_loading = false;
            state.error = action.payload || "Something went wrong";
            state.templates_list = [];
        });
    },
});

export default templateSlice.reducer;
